import { Notification, Message } from "react_reusable_components";
import variables from "../themes/base/styles/variables";

export const showNotificationMsg = (type, message, description) => {
  Notification[type]({
    message: `${message} !`,
    description: `${description}.`,
    placement: "top",
    style: {
      fontFamily: variables.fontFamilyRegular,
      borderRadius: 0,
    },
  });
};

export const showNotification = (type, message, description, duration = 3) => {
  Message.destroy(); // This will close the currently displayed message
  Message[type]({
    content: (
      <span style={{ fontSize: variables.fontSizeNormal }}>
        {message && `${message}:`} {description} !
      </span>
    ),
    duration,
    style: {
      fontFamily: variables.fontFamilyRegular,
      borderRadius: 0,
    },
  });
};
